export function getdata() {
	var obj = {
		searchlist: [{
				prop: "shuiybh",
				label: '税源编号',
				type: "input"
			},
			{
				prop: "paifkmc",
				label: '排放口名称',
				type: "input"
			},


		],
		searchdata: {
			shuiybh: "",
			paifkmc: "",
		},
	}
	return obj
}
